import * as React from 'react';
import classnames from 'classnames';

var Spinner = function Spinner(_ref) {
  var type = _ref.type,
      className = _ref.className;

  var _className = classnames(className, 'Spinner', "Spinner--".concat(type));

  switch (type) {
    case 'dots':
      return React.createElement("span", {
        className: _className
      }, React.createElement("span", {
        className: "Spinner__dot"
      }), React.createElement("span", {
        className: "Spinner__dot"
      }), React.createElement("span", {
        className: "Spinner__dot"
      }));

    case 'round':
    default:
      return React.createElement("svg", {
        viewBox: "0 0 50 50",
        className: _className
      }, React.createElement("circle", {
        className: "Spinner__path",
        cx: "25",
        cy: "25",
        r: "20",
        fill: "none",
        strokeMiterlimit: "10"
      }));
  }
};

Spinner.defaultProps = {
  type: 'round',
  className: undefined
};
export default Spinner;